import { render, staticRenderFns } from "./PartGroupInput.vue?vue&type=template&id=684a5fc8&"
import script from "./PartGroupInput.vue?vue&type=script&lang=js&"
export * from "./PartGroupInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports